import client from './client';

export const getFavoritesApi = () => client().get('Product/GetFavorites');

export const addRemoveFromFavoritesApi = ({ id }) =>
  client().put(`Product/AddRemoveFromFavorites/${id}`);

export const getDetalisApi = (id) => client().get(`Product/Details/${id}`);
